<template>
  <div>
    <div slot="content">
      <div class="d-flex w-50 mb-4">
        <input type="number" class="form-control" placeholder="Nhập id data ..." v-model.number="order_detail_id"/>
        <b-button variant="warning" @click="search" style="margin-left: 10px">
          <span class="glyphicon glyphicon-search" aria-hidden="true"></span> Tìm kiếm
        </b-button>
      </div>
      <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty>
        <template #table-busy>
          <div class="text-center my-2 mt-5 mb-5">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Đang tải...</strong>
          </div>
        </template>

        <template #empty="scope">
          <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
        </template>

        <template #cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>

        <template v-slot:cell(id)="data">
          {{data.item.id}}
        </template>
        <template v-slot:cell(product)="data">
          {{data.item.product.name}}
        </template>
        <template v-slot:cell(paid_payment_amount)="data">
          <span v-if="!data.item.editMode">{{data.item.paid_payment_amount | format_currency}}</span>
          <input v-else type="number" class="form-control" v-model.number="data.item.paid_payment_amount" @change="calculatePrice(data.item)"/>
        </template>
        <template v-slot:cell(remaining_payment_amount)="data">
          <span v-if="!data.item.editMode">{{data.item.remaining_payment_amount | format_currency}}</span>
          <input v-else type="number" class="form-control" v-model.number="data.item.remaining_payment_amount" disabled/>
        </template>
        <template v-slot:cell(debt)="data">
          {{data.item.debt | format_currency}}
        </template>
        <template v-slot:cell(discount_value)="data">
          <span v-if="!data.item.editMode">{{data.item.discount_value}}</span>
          <input v-else type="number" class="form-control" v-model.number="data.item.discount" @change="calculatePrice(data.item)"/>
        </template>
        <template v-slot:cell(price)="data">
          <span v-if="!data.item.editMode">{{data.item.price | format_currency}}</span>
          <input v-else type="number" class="form-control" v-model.number="data.item.price" @change="calculatePrice(data.item)"/>
        </template>
        <template v-slot:cell(quantity)="data">
          <span v-if="!data.item.editMode">{{data.item.quantity}}</span>
          <input v-else type="number" class="form-control" v-model.number="data.item.quantity" @change="calculatePrice(data.item)"/>
        </template>
        <template v-slot:cell(invoice)="data">
          <span v-if="!data.item.editMode">{{data.item.invoice}}</span>
          <input v-else type="text" class="form-control" v-model="data.item.invoice"/>
        </template>
        <template v-slot:cell(due_date)="data">
          <span v-if="!data.item.editMode">{{data.item.due_date}}</span>
          <date-picker v-else v-model="data.item.due_date" valueType="format"></date-picker>
        </template>
        <template v-slot:cell(created_at)="data">
          {{data.item.created_at | format_date_time}}
        </template>

      </b-table>
    </div>

    <div slot="footer" class="d-flex align-items-center justify-content-between">
      <div class="page-size-container">
        <span>Hiển thị</span>
        <b-form-select
          id="pageSize"
          v-model="pageSize"
          :options="pageSizes"
          required
        ></b-form-select>
        <span>  dòng</span>
      </div>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRow"
        :per-page="pageSize"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import Box from '../../components/Box'
import OrderDetailApi from '../../api/orderDetailApi'
import Utils from '../../common/utils'
import DatePicker from 'vue2-datepicker'
import {mapGetters} from 'vuex'
import {isNumber} from 'lodash'
import ProductTable from '../../components/ProductTable'

export default {
  name: 'OrderDetailHistory',
  components: {
    Box,
    DatePicker,
    ProductTable
  },
  props: {
    orderId: {
      type: Number,
      required: false
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      company: null,
      fields: [
        {
          key: 'id',
          label: 'ID',
          show: true
        }, {
          key: 'product',
          label: 'Sản phẩm',
          show: true
        }, {
          key: 'quantity',
          label: 'Số lượng',
          show: true
        }, {
          key: 'price',
          label: 'Giá tiền',
          show: true
        }, {
          key: 'discount_value',
          label: 'Giảm giá',
          show: true
        }, {
          key: 'remaining_payment_amount',
          label: 'Số tiền cần thanh toán',
          show: true
        }, {
          key: 'due_date',
          label: 'Hạn thanh toán',
          show: true
        }, {
          key: 'invoice',
          label: 'Số hoá đơn',
          show: true
        }, {
          key: 'created_at',
          label: 'Thời gian sửa',
          show: true
        }
      ],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      selectedOrderHistoryDetail: null,
      orderHistoryDetail: {
        order_id: this.orderId,
        type: this.type,
        company_id: null,
        product_id: null,
        product_name: null,
        quantity: 0,
        price: 0,
        discount: 0,
        remaining_payment_amount: 0,
        paid_payment_amount: 0,
        debt: 0,
        due_date: null,
        invoice: null
      },
      order_detail_id: null,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      items: [
      ],
      modalTitle: 'Thêm mới',
      isEditable: true,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ]),
    errorQuantity: function () {
      return !isNumber(this.orderHistoryDetail.quantity)
    },
    errorPrice: function () {
      return !isNumber(this.orderHistoryDetail.price)
    }
  },
  mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  },
  methods: {
    validate () {
      return !this.errorQuantity && !this.errorPrice
    },
    isEmpty (value) {
      return (this.click && (value == null || value.length <= 0))
    },
    buildFilterData () {
      if (this.order_detail_id !== null && isNumber(this.order_detail_id)) {
        return {order_id: this.orderId, type: this.type, order_detail_id: this.order_detail_id}
      }

      return {order_id: this.orderId, type: this.type}
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      OrderDetailApi.filter_order_detail_history(this.buildFilterData(), this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    edit (selectedRow) {
      this.items = this.items.map(item => {
        if (item.id === selectedRow.id) {
          item.editMode = true
        }
        return item
      })
    },
    showAddModal () {
      this.$bvModal.show('listSelectProductModal' + this.type)
    },
    calculatePrice (selectedRow) {
      this.items = this.items.map(item => {
        if (item.id === selectedRow.id) {
          if (isNumber(item.quantity) && isNumber(item.price) && isNumber(item.discount) && isNumber(item.paid_payment_amount)) {
            item.remaining_payment_amount = item.quantity * item.price - item.discount - item.paid_payment_amount
          }
          item.debt = item.quantity * item.price - item.discount - item.paid_payment_amount
        }
        return item
      })
    },
    selectedProduct (product) {
      this.$bvModal.hide('listSelectProductModal' + this.type)
      const productOrder = {
        id: this.$uuid.v1(),
        order_id: this.orderId,
        type: this.type,
        company_id: null,
        product: {
          id: product.id,
          name: product.name,
        },
        quantity: 1,
        price: product.price,
        discount: 0,
        remaining_payment_amount: product.price,
        paid_payment_amount: 0,
        debt: 0,
        due_date: null,
        invoice: null,
        editMode: true,
        newOrderDetail: true
      }
      this.items.push(productOrder)
    },
    errorSearch () {
      return this.order_detail_id === 0
    },
    search () {
      if (this.errorSearch()) {
        this.$bvToast.toast('ID data không đúng', {
          title: 'Lỗi tìm kiếm',
          variant: 'warn',
          solid: true,
          autoHideDelay: 3000
        })
        return
      }

      this.filter()
    },
  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order_management/OrderDetailHistory.vue